import { Cor, DadoPesquisaCor, FiltroPesquisaCor } from "app/api/classes/ProdutoApi";
import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppDispatch, useAppSelector } from "app/redux/hooks";
import { atualizarCorTintaProdutoSelecionadoAction, limparCorTintaProdutoSelecionadoAction } from "app/redux/produtosSelecionadosSlice";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { PaginaPesquisaProdutoContainer, PesquisaProdutoPagina } from "../PaginaPesquisaProdutoContainer";
import { PesquisaCor } from "./PesquisaCor";
import { IProduto } from "app/types/produto/IProduto";
import { CorTintaSelecionada } from "./cor-selecionada/CorTintaSelecionada";
import { ItensOrcamentoContainer } from "app/components/itens-orcamento/ItensOrcamentoContainer";
import { removerBreadcrumb2 } from "app/components/breadcrumb2/breadcrumb2Utils";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { PesquisaCorTinta } from "./PesquisaCorTinta";
import { Dict } from "app/utils/Dict";


export type PesquisaCorContainerProps = {
  item: IProduto
  dadosGridPesquisaItens: PagedMessageResponse<IProduto>
  fitroAnterior: PesquisaProdutoPagina
  itensSelecionados: IProduto[]
  onVoltar: () => void
  onVoltarPesquisaProdutos: () => void
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  adicionarProdutos?: (produtosSelecionados: IProduto[]) => void
}

export const PesquisaCorContainer = (props: PesquisaCorContainerProps) => {

  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const dispatch = useAppDispatch();
  const [dadosPesquisaCor, setDadosPesquisaCor] = useState<DadoPesquisaCor>();
  const [itemSelecionado, setItemSelecionado] = useState<IProduto>(props.item);
  const [processando, setProcessando] = useState<boolean>(false)
  const [filtros, setFiltros] = useState<FiltroPesquisaCor>({
    CodigoCorFabricante: null,
    CodigoProduto: props.item.Codigo ?? "",
    DescricaoCor: null,
    NumeroPagina: 1,
    TamanhoPagina: 20,
  });

  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
  const itemFoiSelecionado = props.itensSelecionados.filter((y) => y.Codigo == itemSelecionado.Codigo).length > 0

  // 491123 — mesmo padrão de FinalizarOrcamentoContainer/orcamentoConcluidoContainer: sinaliza para
  // _BaseInterno.cshtml esconder o BaseInterno_BotaoFlutuanteCestaProdutos enquanto a tela
  // "Selecionar Cor" estiver montada. Aqui o usuário já está dentro de um sub-fluxo da cesta (o
  // ItemPesquisaProduto_BotaoTinta_* que abriu esta tela pode ser o da própria cesta), então o
  // botão flutuante só serviria para abrir o modal da cesta por cima da configuração da cor.
  useEffect(() => {
    sessionStorage.setItem('selecionandoCorTinta', "true")
    return () => {
      sessionStorage.removeItem('selecionandoCorTinta')
    }
  }, [])


  const pesquisar = async (filtroPesquisa: FiltroPesquisaCor) => {

    try {
      globalMU.blockUI();
      setFiltros(filtroPesquisa);
      const dadosCores = await microuniversoApi.Produto.pesquisaCor(
        filtroPesquisa
      );
      setDadosPesquisaCor(dadosCores);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const pesquisaPaginada = async (numeroIndexPagina: number) => {
    globalMU.blockUI();
    try {
      const filtrosAlterado = { ...filtros, NumeroPagina: numeroIndexPagina };
      setFiltros(filtros);
      const dadosCores = await microuniversoApi.Produto.pesquisaCor(
        filtrosAlterado
      );
      setDadosPesquisaCor(dadosCores);
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };


  const produtoAdicionadoOrcamento = async (cor: Cor) => {

    globalMU.blockUI();
    try {
      const identificador = orcamento.IdentificadorOrcamento
      const produto = { ...itemSelecionado, CorTinta: cor };
      const resposta = await microuniversoApi.Orcamento.produtoAdicionadoOrcamento(
        identificador, produto
      );
      return resposta
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const validarCorInformada = async (cor: Cor) => {

    globalMU.blockUI();
    try {
      const produto = { ...itemSelecionado, CorTinta: cor };
      const resposta = await microuniversoApi.Produto.ValidarCorInformada(
        cor.Codigo,
        produto.Codigo
      );
      return resposta
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };


  const obterPrecoProdutoTintaPesquisa = async (cor: Cor) => {

    globalMU.blockUI();
    try {
      const identificador = orcamento.IdentificadorOrcamento
      const produto = { ...itemSelecionado, CorTinta: cor };
      const resposta = await microuniversoApi.Produto.obterPrecoProdutoTintaPesquisa(identificador, produto);

      return resposta
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const construirDadosGridComItemAtualizado = (itemAtualizado: IProduto) => {
    // 491123 — dadosGridPesquisaItens vem null quando a tinta é selecionada a partir da cesta
    // (host oculto do botão flutuante, que nunca chegou a pesquisar produtos): sem esse fallback,
    // ".Entities" em null quebrava silenciosamente o retorno para a pesquisa de produtos.
    const entidadesAtuais = props.dadosGridPesquisaItens?.Entities ?? []
    const produtosAlterados = entidadesAtuais.map((x) =>
      x.Codigo == itemAtualizado.Codigo ? { ...itemAtualizado } : { ...x }
    )
    return { ...(props.dadosGridPesquisaItens ?? {}), Entities: produtosAlterados }
  }

  const retornarParaPesquisaProdutos = (itemAtualizado: IProduto, onVoltarCallback: () => void) => {
    const dadosGridItens = construirDadosGridComItemAtualizado(itemAtualizado)

    renderizarComponentReact(
      <PaginaPesquisaProdutoContainer
        chamadoParaInserirProdutoNoOrcamento={true}
        pesquisandoApenasParaFiltroProdutosLupa={false}
        foraOrcamento={false}
        chamadoPeloTrocarProduto={false}
        adicionarProdutos={props.adicionarProdutos}
        passos={props.passos.remove("Pesquisar Produtos")}
        onVoltar={onVoltarCallback}
        dadosGridPesquisaItens={dadosGridItens} filtroAnterior={props.fitroAnterior}
        regiaoRenderizada={props.regiaoRenderizada}
        itensSelecionados={itemFoiSelecionado ? (dadosGridItens?.Entities ?? []).filter((y) => props.itensSelecionados.map((x) => x.Codigo).includes(y.Codigo)) :
          (dadosGridItens?.Entities ?? []).filter((y) => props.itensSelecionados.concat(itemAtualizado).map((x) => x.Codigo).includes(y.Codigo))} />,
      props.regiaoRenderizada,
      true
    )
  }

  const onLimpar = () => {
    const itemAlterado = { ...itemSelecionado, CorTinta: null, Configurado: null }
    setItemSelecionado(itemAlterado)
    // 491123 — identificador de linha da cesta, não Codigo: itemSelecionado pode ser uma duplicata
    // de "Inserir Novo", e duas duplicatas compartilham o mesmo Codigo (ver APRENDIZADOS #179)
    dispatch(limparCorTintaProdutoSelecionadoAction(itemAlterado.IdentificadorLinhaCesta ?? itemAlterado.Codigo))
  }

  const onVoltar = () => {
    retornarParaPesquisaProdutos(itemSelecionado, props.onVoltarPesquisaProdutos)
  }

  const onPassoSelecionado = (passo: string) => {
    passosInterno.current.get(passo)()
  }

  return (

    <>
      <Breadcrumb2Container
        passos={passosInterno.current.set("Selecionar Cor", () => { }).keysToList()}
        exibirBotaoLimpar={itemSelecionado.CorTinta == null ? false : true}
        exibirBotaoVoltar={true}
        id="PesquisaCorContainer"
        onPassoSelecionado={onPassoSelecionado}
        onBotaoLimparClicado={onLimpar}
        onBotaoVoltarClicado={onVoltar}
        processando={processando}
      />


      {itemSelecionado.CorTinta == null ? <PesquisaCor
        tintometricoSimplificado={itemSelecionado.BaseTintometricoSimplificado}
        filtro={filtros}
        cores={dadosPesquisaCor}
        corFundoSelecionado={
          globalMU.sessionStorage.getData("UsuarioLogado")?.CorFundo
        }
        corTextoSelecionado={
          globalMU.sessionStorage.getData("UsuarioLogado")?.CorTexto
        }
        onPesquisar={pesquisar}
        onAlterarListaSelecionada={(numeroPagina) =>
          pesquisaPaginada(numeroPagina)
        }
        onClickSelecionado={async (cor) => {

          var respostaValidacaoCorInformada = await validarCorInformada(cor);
          if (respostaValidacaoCorInformada["HasErrors"] != undefined) {
            return true
          }

          let repetido = await produtoAdicionadoOrcamento(cor);

          let precoProduto = await obterPrecoProdutoTintaPesquisa(cor);
          const itemAlterado = { ...itemSelecionado, CorTinta: cor, Configurado: true, Preco: precoProduto, Repetido: repetido }

          // Mantém em sincronia o carrinho de produtos selecionados (redux), já que o item
          // aberto para configurar a tinta pode ter vindo de lá (TabelaProdutosSelecionados).
          // 491123 — identificador de linha, não Codigo: ver onLimpar acima
          dispatch(atualizarCorTintaProdutoSelecionadoAction({
            codigo: itemSelecionado.IdentificadorLinhaCesta ?? itemSelecionado.Codigo,
            corTinta: cor,
            preco: precoProduto,
            repetido: repetido,
          }))

          retornarParaPesquisaProdutos(itemAlterado, props.onVoltarPesquisaProdutos)
        }} />
        : <CorTintaSelecionada
          //produto={itemSelecionado} 
          tintometricoSimplificado={itemSelecionado.BaseTintometricoSimplificado}
          codigoCorTinta={itemSelecionado.CorTinta?.CodigoExterno}
          descricaoCorTinta={itemSelecionado.CorTinta?.Nome?.trimEnd()}
        />
      }
    </>
  );
};